import React from 'react';

import { Link } from './Sidebar';
import { SidebarLink } from './SidebarLink/SidebarLink';

export interface Props {
  links: Link[];
  onSelectLink?: () => void;
}

export function SidebarLinks({ links, onSelectLink }: Props): JSX.Element {
  return (
    <ul className="sidebar-links">
      {links.map((link, index) => {
        return (
          <li className="sidebar-links__item" key={index}>
            <SidebarLink link={link} onSelectLink={onSelectLink} />
          </li>
        );
      })}
    </ul>
  );
}
